export const CUSTOM_STYLE_DEFINITIONS = [
    {
        name: 'Italic Title',
        type: 'block',
        className: 'ck-style-italic-title',
        dataStyle: 'font-size:1.8em;font-weight:bold;font-style:italic;font-family:Georgia,serif;'
    },
    {
        name: 'Subtitle',
        type: 'block',
        className: 'ck-style-subtitle',
        dataStyle: 'font-size:0.9em;color:#666666;font-style:italic;'
    },
    {
        name: 'Special Container',
        type: 'block',
        className: 'ck-style-special-container',
        dataStyle: 'padding:10px;border:1px solid #cccccc;background:#f5f5f5;'
    },
    {
        name: 'Marker',
        type: 'inline',
        className: 'ck-style-marker',
        dataStyle: 'background-color:#ffff00;'
    },
    {
        name: 'Big',
        type: 'inline',
        className: 'ck-style-big',
        dataStyle: 'font-size:1.25em;'
    },
    {
        name: 'Small',
        type: 'inline',
        className: 'ck-style-small',
        dataStyle: 'font-size:0.85em;'
    },
    {
        name: 'Typewriter',
        type: 'inline',
        className: 'ck-style-typewriter',
        dataStyle: 'font-family:Courier New,Courier,monospace;'
    },
    {
        name: 'Computer Code',
        type: 'inline',
        className: 'ck-style-computer-code',
        dataStyle: 'font-family:Courier New,Courier,monospace;background:#f4f4f4;padding:2px 4px;'
    },
    {
        name: 'Keyboard Phrase',
        type: 'inline',
        className: 'ck-style-keyboard-phrase',
        element: 'kbd',
        dataStyle: 'font-family:Courier New,Courier,monospace;border:1px solid #cccccc;padding:2px 4px;border-radius:3px;'
    },
    {
        name: 'Sample Text',
        type: 'inline',
        className: 'ck-style-sample-text',
        element: 'samp',
        dataStyle: 'font-family:Arial,Helvetica,sans-serif;'
    },
    {
        name: 'Variable',
        type: 'inline',
        className: 'ck-style-variable',
        element: 'var',
        dataStyle: 'font-style:italic;'
    },
    {
        name: 'Deleted Text',
        type: 'inline',
        className: 'ck-style-deleted-text',
        element: 'del',
        dataStyle: 'text-decoration:line-through;'
    },
    {
        name: 'Inserted Text',
        type: 'inline',
        className: 'ck-style-inserted-text',
        element: 'ins',
        dataStyle: 'text-decoration:underline;'
    },
    {
        name: 'Cited Work',
        type: 'inline',
        className: 'ck-style-cited-work',
        element: 'cite',
        dataStyle: 'font-style:italic;'
    },
    {
        name: 'Inline Quotation',
        type: 'inline',
        className: 'ck-style-inline-quotation',
        element: 'q',
        dataStyle: 'font-style:italic;'
    },
    {
        name: 'Language: RTL',
        type: 'block',
        className: 'ck-style-language-rtl',
        dir: 'rtl',
        dataStyle: 'direction:rtl;text-align:right;'
    },
    {
        name: 'Language: LTR',
        type: 'block',
        className: 'ck-style-language-ltr',
        dir: 'ltr',
        dataStyle: 'direction:ltr;text-align:left;'
    }
];

const BLOCK_CLASS_NAMES = CUSTOM_STYLE_DEFINITIONS
    .filter((definition) => definition.type === 'block')
    .map((definition) => definition.className);

const INLINE_CLASS_NAMES = CUSTOM_STYLE_DEFINITIONS
    .filter((definition) => definition.type === 'inline')
    .map((definition) => definition.className);

function findStyleDefinition(styleName) {
    return CUSTOM_STYLE_DEFINITIONS.find((definition) => definition.name === styleName);
}

function findStyleByClassName(className) {
    return CUSTOM_STYLE_DEFINITIONS.find((definition) => definition.className === className);
}

const NORMAL_STYLE_NAME = 'Normal';

function getInlineStyleFromSelection(selection) {
    const selectionAttribute = selection.getAttribute('inlineStyle');
    if (selectionAttribute) {
        return selectionAttribute;
    }

    if (!selection.isCollapsed) {
        return null;
    }

    const position = selection.getFirstPosition();
    const textNode = position.textNode;

    if (textNode && textNode.hasAttribute('inlineStyle')) {
        return textNode.getAttribute('inlineStyle');
    }

    return null;
}

function getActiveStyleName(editor) {
    const selection = editor.model.document.selection;

    if (!selection.isCollapsed) {
        let firstInlineStyle = null;
        let isUniformInline = true;

        for (const range of selection.getRanges()) {
            for (const item of range.getItems()) {
                if (!item.is('$text')) {
                    continue;
                }

                const inlineStyle = item.hasAttribute('inlineStyle')
                    ? item.getAttribute('inlineStyle')
                    : null;

                if (firstInlineStyle === null) {
                    firstInlineStyle = inlineStyle;
                } else if (firstInlineStyle !== inlineStyle) {
                    isUniformInline = false;
                    break;
                }
            }

            if (!isUniformInline) {
                break;
            }
        }

        if (isUniformInline && firstInlineStyle) {
            const definition = findStyleByClassName(firstInlineStyle);
            if (definition) {
                return definition.name;
            }
        }
    } else {
        const inlineStyle = getInlineStyleFromSelection(selection);
        if (inlineStyle) {
            const definition = findStyleByClassName(inlineStyle);
            if (definition) {
                return definition.name;
            }
        }
    }

    const selectedBlock = selection.getSelectedBlocks().next().value;
    if (selectedBlock && selectedBlock.is('element', 'paragraph') && selectedBlock.hasAttribute('blockStyle')) {
        const definition = findStyleByClassName(selectedBlock.getAttribute('blockStyle'));
        if (definition) {
            return definition.name;
        }
    }

    return '';
}

function clearCustomStyles(writer, editor) {
    const selection = editor.model.document.selection;

    writer.removeSelectionAttribute('inlineStyle');

    const blocks = Array.from(selection.getSelectedBlocks());

    blocks.forEach((block) => {
        if (block.is('element', 'paragraph') && block.hasAttribute('blockStyle')) {
            writer.removeAttribute('blockStyle', block);
        }
    });

    const ranges = editor.model.schema.getValidRanges(selection.getRanges(), 'inlineStyle');
    ranges.forEach((range) => {
        writer.removeAttribute('inlineStyle', range);
    });
}

function applyInlineStyle(writer, model, selection, className) {
    if (selection.isCollapsed) {
        writer.setSelectionAttribute('inlineStyle', className);
        return;
    }

    writer.removeSelectionAttribute('inlineStyle');

    const ranges = model.schema.getValidRanges(selection.getRanges(), 'inlineStyle');
    ranges.forEach((range) => {
        writer.removeAttribute('inlineStyle', range);
        writer.setAttribute('inlineStyle', className, range);
    });
}

function getViewClass(editor) {
    const ButtonView = editor.ui.componentFactory.create('bold').constructor;
    return Object.getPrototypeOf(ButtonView.prototype).constructor;
}

class ApplyCustomStyleCommand {
    constructor(editor) {
        this.editor = editor;
        this.isEnabled = true;
        this.value = '';
    }

    refresh() {
        this.isEnabled = !this.editor.isReadOnly;
        this.value = getActiveStyleName(this.editor) || NORMAL_STYLE_NAME;
    }

    execute({ styleName }) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;

        if (!styleName || styleName === NORMAL_STYLE_NAME) {
            model.change((writer) => {
                clearCustomStyles(writer, editor);
            });
            this.refresh();
            return;
        }

        const definition = findStyleDefinition(styleName);
        if (!definition) {
            return;
        }

        model.change((writer) => {
            if (definition.type === 'block') {
                const blocks = Array.from(selection.getSelectedBlocks());
                blocks.forEach((block) => {
                    if (!block.is('element', 'paragraph')) {
                        return;
                    }

                    writer.setAttribute('blockStyle', definition.className, block);
                });
                return;
            }

            applyInlineStyle(writer, model, selection, definition.className);
        });

        this.refresh();
    }

    destroy() {}
}

export class CustomStylesEditing {
    static get pluginName() {
        return 'CustomStylesEditing';
    }

    constructor(editor) {
        this.editor = editor;
    }

    init() {
        const editor = this.editor;

        editor.model.schema.extend('paragraph', { allowAttributes: ['blockStyle'] });
        editor.model.schema.extend('$text', { allowAttributes: ['inlineStyle'] });
        editor.model.schema.setAttributeProperties('inlineStyle', {
            copyOnReplace: true,
            copyFromObject: true
        });

        const applyCustomStyleCommand = new ApplyCustomStyleCommand(editor);
        editor.commands.add('applyCustomStyle', applyCustomStyleCommand);

        editor.model.document.selection.on('change:range', () => {
            applyCustomStyleCommand.refresh();
        });
        editor.model.document.selection.on('change:attribute', () => {
            applyCustomStyleCommand.refresh();
        });
        editor.model.document.selection.on('change:marker', () => {
            applyCustomStyleCommand.refresh();
        });
        editor.model.document.on('change:data', () => {
            applyCustomStyleCommand.refresh();
        });

        applyCustomStyleCommand.refresh();

        this._registerBlockConversion();
        this._registerInlineConversion();
        this._setupBlockStyleBackspace();
    }

    _setupBlockStyleBackspace() {
        const editor = this.editor;
        const deleteCommand = editor.commands.get('delete');

        deleteCommand.on('execute', () => {
            const model = editor.model;
            const selection = model.document.selection;

            if (!selection.isCollapsed) {
                return;
            }

            const position = selection.getFirstPosition();
            const block = position.parent;

            if (!block.is('element', 'paragraph') || !block.hasAttribute('blockStyle')) {
                return;
            }

            if (!position.isAtStart) {
                return;
            }

            model.enqueueChange({ isUndoable: true }, (writer) => {
                writer.removeAttribute('blockStyle', block);
            });
        }, { priority: 'high' });
    }

    _registerBlockConversion() {
        const editor = this.editor;

        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'p',
                classes: true
            },
            model: {
                key: 'blockStyle',
                value: (viewElement) => {
                    const match = BLOCK_CLASS_NAMES.find((className) => viewElement.hasClass(className));
                    return match || null;
                }
            }
        });

        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'p',
                attributes: {
                    dir: ['rtl', 'ltr']
                }
            },
            model: {
                key: 'blockStyle',
                value: (viewElement) => {
                    const dir = viewElement.getAttribute('dir');
                    if (dir === 'rtl') {
                        return 'ck-style-language-rtl';
                    }
                    if (dir === 'ltr') {
                        return 'ck-style-language-ltr';
                    }
                    return null;
                }
            }
        });

        const downcastBlockStyle = (writer, viewElement, className, definition, pipeline) => {
            BLOCK_CLASS_NAMES.forEach((blockClassName) => {
                writer.removeClass(blockClassName, viewElement);
            });
            writer.removeAttribute('style', viewElement);
            writer.removeAttribute('dir', viewElement);

            if (className && definition) {
                writer.addClass(className, viewElement);
                if (definition.dir) {
                    writer.setAttribute('dir', definition.dir, viewElement);
                }
                if (pipeline === 'data' && definition.dataStyle) {
                    writer.setAttribute('style', definition.dataStyle, viewElement);
                }
            }
        };

        editor.conversion.for('editingDowncast').add((dispatcher) => {
            dispatcher.on('attribute:blockStyle:paragraph', (evt, data, conversionApi) => {
                const viewElement = conversionApi.mapper.toViewElement(data.item);
                if (!viewElement) {
                    return;
                }

                const definition = findStyleByClassName(data.attributeNewValue);
                downcastBlockStyle(
                    conversionApi.writer,
                    viewElement,
                    data.attributeNewValue,
                    definition,
                    'editing'
                );
            });
        });

        editor.conversion.for('dataDowncast').add((dispatcher) => {
            dispatcher.on('attribute:blockStyle:paragraph', (evt, data, conversionApi) => {
                const viewElement = conversionApi.mapper.toViewElement(data.item);
                if (!viewElement) {
                    return;
                }

                const definition = findStyleByClassName(data.attributeNewValue);
                downcastBlockStyle(
                    conversionApi.writer,
                    viewElement,
                    data.attributeNewValue,
                    definition,
                    'data'
                );
            });
        });
    }

    _registerInlineConversion() {
        const editor = this.editor;

        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'span',
                classes: true
            },
            model: {
                key: 'inlineStyle',
                value: (viewElement) => {
                    const match = INLINE_CLASS_NAMES.find((className) => viewElement.hasClass(className));
                    return match || null;
                }
            }
        });

        CUSTOM_STYLE_DEFINITIONS
            .filter((definition) => definition.type === 'inline' && definition.element)
            .forEach((definition) => {
                editor.conversion.for('upcast').elementToAttribute({
                    view: definition.element,
                    model: {
                        key: 'inlineStyle',
                        value: definition.className
                    }
                });
            });

        editor.conversion.for('downcast').attributeToElement({
            model: 'inlineStyle',
            view: (className, { writer }) => {
                if (!className) {
                    return null;
                }

                const definition = findStyleByClassName(className);
                const tagName = (definition && definition.element) || 'span';
                const attributes = { class: className };

                if (definition && definition.dataStyle) {
                    attributes.style = definition.dataStyle;
                }

                return writer.createAttributeElement(tagName, attributes, { priority: 5 });
            },
            converterPriority: 'high'
        });
    }
}

export class CustomStylesUI {
    static get pluginName() {
        return 'CustomStylesUI';
    }

    static get requires() {
        return [CustomStylesEditing];
    }

    constructor(editor) {
        this.editor = editor;
    }

    init() {
        const editor = this.editor;
        const View = getViewClass(editor);
        const styleCommand = editor.commands.get('applyCustomStyle');

        class StylesDropdownView extends View {
            constructor(locale) {
                super(locale);
                this.setTemplate({
                    tag: 'div',
                    attributes: {
                        class: ['ck', 'ck-styles-toolbar-dropdown']
                    }
                });
            }

            render() {
                super.render();

                const select = document.createElement('select');
                select.className = 'ck ck-custom-styles-select';
                select.setAttribute('aria-label', 'Styles');

                const normalOption = document.createElement('option');
                normalOption.value = NORMAL_STYLE_NAME;
                normalOption.textContent = 'Normal';
                select.appendChild(normalOption);

                const blockGroup = document.createElement('optgroup');
                blockGroup.label = 'Block Styles';
                CUSTOM_STYLE_DEFINITIONS
                    .filter((definition) => definition.type === 'block')
                    .forEach((definition) => {
                        const option = document.createElement('option');
                        option.value = definition.name;
                        option.textContent = definition.name;
                        blockGroup.appendChild(option);
                    });
                select.appendChild(blockGroup);

                const inlineGroup = document.createElement('optgroup');
                inlineGroup.label = 'Inline Styles';
                CUSTOM_STYLE_DEFINITIONS
                    .filter((definition) => definition.type === 'inline')
                    .forEach((definition) => {
                        const option = document.createElement('option');
                        option.value = definition.name;
                        option.textContent = definition.name;
                        inlineGroup.appendChild(option);
                    });
                select.appendChild(inlineGroup);

                const syncDropdownValue = () => {
                    styleCommand.refresh();
                    const activeStyle = styleCommand.value || NORMAL_STYLE_NAME;
                    const hasOption = Array.from(select.options).some((option) => option.value === activeStyle);
                    select.value = hasOption ? activeStyle : NORMAL_STYLE_NAME;
                };

                select.addEventListener('change', () => {
                    if (!select.value) {
                        syncDropdownValue();
                        return;
                    }

                    editor.execute('applyCustomStyle', { styleName: select.value });
                    editor.editing.view.focus();
                    syncDropdownValue();
                });

                editor.model.document.selection.on('change:range', syncDropdownValue);
                editor.model.document.selection.on('change:attribute', syncDropdownValue);
                editor.model.document.on('change:data', syncDropdownValue);

                this.element.appendChild(select);
                this.selectElement = select;
                syncDropdownValue();
            }
        }

        editor.ui.componentFactory.add('customStyles', (locale) => new StylesDropdownView(locale));
    }
}
